// Familias del cielo de modelos (guía 7.2 y 11). Fuente: referencia/datos/
// familias_auditoria.json (re-chequeo del 1 de octubre de 2026 sobre 10.808 modelos).
// Se copian acá porque referencia/ queda fuera de la app.
//
// Qué es real y qué es visual:
// - La PROPORCIÓN entre familias es la medida: 24 familias principales, 397 familias
//   chicas (1.284 modelos en total) y 1.360 modelos sin familia declarada. Esos 8.115
//   modelos clasificados se escalan a los ≈ 25.700 de la auditoría completa.
// - Las cantidades por familia que muestra la Auditoría son las del re-chequeo, con esa
//   aclaración en pantalla.
// - Las posiciones son visuales. No hay nombres de modelos individuales.
// - Región: el JSON trae solo el total por región (8.644 / 15.804 / 1.294), no el cruce
//   familia × región. Cada punto recibe una región al azar con esa proporción, así que el
//   filtro por región muestra cuántos son, no qué familias usa cada región.

export type Family = { id: string; name: string; count: number };

export const TOP_FAMILIES: Family[] = [
  { id: "llama", name: "Llama", count: 2228 },
  { id: "mistral", name: "Mistral", count: 499 },
  { id: "lfm2", name: "LFM2", count: 349 },
  { id: "qwen2", name: "Qwen2", count: 268 },
  { id: "nemotron_h", name: "Nemotron-H", count: 233 },
  { id: "qwen3", name: "Qwen3", count: 201 },
  { id: "granite", name: "Granite", count: 185 },
  { id: "cohere", name: "Cohere", count: 181 },
  { id: "mixtral", name: "Mixtral", count: 169 },
  { id: "gpt2", name: "GPT-2", count: 159 },
  { id: "lfm2_moe", name: "LFM2 MoE", count: 95 },
  { id: "phi3", name: "Phi-3", count: 88 },
  { id: "qwen3_5", name: "Qwen3.5", count: 81 },
  { id: "cohere2", name: "Cohere2", count: 80 },
  { id: "bloom", name: "BLOOM", count: 79 },
  { id: "afmoe", name: "AFMoE", count: 75 },
  { id: "omnivoice", name: "OmniVoice", count: 75 },
  { id: "mt5", name: "mT5", count: 71 },
  { id: "mistral3", name: "Mistral3", count: 67 },
  { id: "smollm3", name: "SmolLM3", count: 66 },
  { id: "gemma3_text", name: "Gemma 3", count: 63 },
  { id: "m2m_100", name: "M2M-100", count: 63 },
  { id: "t5", name: "T5", count: 51 },
  { id: "gemma4", name: "Gemma 4", count: 45 },
];

export const OTHER_FAMILIES = { id: "otras", name: "Otras 397 familias", count: 1284, families: 397 };
export const NO_FAMILY = { id: "sin-familia", name: "Sin familia declarada", count: 1360 };

/** Todas las agrupaciones en el orden de los índices que usa la escena. */
export const SKY_GROUPS: Family[] = [...TOP_FAMILIES, OTHER_FAMILIES, NO_FAMILY];

export const CLASSIFIED_TOTAL = SKY_GROUPS.reduce((n, f) => n + f.count, 0); // 8.115
export const SKY_POINTS = 25700;

export const REGIONS = [
  { id: "latam", name: "Latinoamérica hispana y lenguas indígenas", count: 8644 },
  { id: "brasil", name: "Brasil y portugués", count: 15804 },
  { id: "espana", name: "España", count: 1294 },
] as const;
